import { styled } from "@mui/material/styles";
import { BrandCustom } from "../../../models/brand.custom";

export const FooterLink = styled("a")(() => ({
  marginLeft: "30px",
}));

export const ItemFooter = styled("div")(() => ({
  marginLeft: "30px",
}));

export const Subtitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  color: "#FFFFFF",
  fontWeight: 600,
  lineHeight: "16px",
}));

export const PoweredBy = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  color: "#FFFFFF",
  fontWeight: 600,
  lineHeight: "16px",
  paddingLeft: "10px",
}));

export const DivFlex = styled("div")<FooterContainerProps>(({ brandCustom }) => ({
  display: "flex",
  alignItems: "flex-end",
  paddingBottom: brandCustom?.enableCustomLogo ? "20px" : undefined,
}));

export const DivColumn = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
}));

export const ShipeeziLogo = styled("img")(() => ({
  width: "120px",
}));

export const AboutUs = styled("a")(() => ({
  marginLeft: "30px",
}));

interface FooterContainerProps {
  brandCustom?: BrandCustom;
}

export const FooterContainer = styled("div")<FooterContainerProps>(({ brandCustom }) => ({
  height: "78px",
  backgroundColor: brandCustom?.enableCustomLogo ? "#475467" : "#93A9BD",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "30px 32px",
  "@media (max-width: 959px)": {
    justifyContent: "center",
  },
}));
